import { AjaxResponse } from 'rxjs/ajax';
import { throwError } from 'rxjs/internal/observable/throwError';
declare var Swal: any;

export function handleError(error: AjaxResponse) {
  let errorMessage = "Oops! Something went wrong. Please try again later."
  const errorStatuses = [400, 500, 401, 403, 404, 409, 422, 502, 503, 504];
  if (errorStatuses.includes(error.status) && error.response) {

    if (error.response.message && typeof error.response.message == 'string') {
      errorMessage = error.response.message
    }
    else if (error.response && typeof error.response == 'string') {
      errorMessage = error.response
    }
    else {
      errorMessage = Object.keys(error.response)
        .map(key => `<div>${error.response[key].join('\n')}</div>`)
        .join('\n');
    }

  } else {
    console.error('Error:', error);
  }

  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    html: errorMessage,
  });

  return throwError(error);
}

export function parseBoolean(value) {
  if (typeof value === 'boolean') {
    return value;
  } else if (typeof value === 'string') {
    const lowerValue = value.toLowerCase();
    if (lowerValue === 'true') {
      return true;
    } else if (lowerValue === 'false') {
      return false;
    }
  }
}